import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  PRODUCT_ORDERS_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import ProductsOrdersIndex from './Index.vue';

const commonMeta = {
  permissions: [...ROLES, PRODUCT_ORDERS_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/products-orders'),
    component: ProductsOrdersIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'products_orders_index',
        component: ProductsOrdersIndex,
        meta: commonMeta,
      },
    ],
  },
];
